import React from 'react';
import { CheckCircle2Icon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
const productImage = 'https://cdn.magicpatterns.com/uploads/jMJpMNFgpjc5spsvfj7eWq/Diseno-sin-titulo-2026-07-14T185739.151.webp';
export function HeroSection() {
  return <section className="bg-[#0A0A0A] px-5 py-6 sm:py-16" data-id="element-100">
      <div className="mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-[1.05fr_.95fr] lg:gap-14" data-id="element-101">
        <div className="text-center lg:text-left" data-id="element-102">
          <p className="mb-3 inline-flex items-center gap-2 rounded-full border border-emerald-400/40 bg-emerald-400/10 px-3 py-1.5 text-[9px] font-bold uppercase tracking-[.14em] text-emerald-300 sm:mb-5 sm:px-4 sm:py-2 sm:text-[11px]" data-id="element-103">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 sm:h-2 sm:w-2" data-id="element-104" />
            Il sistema di pianificazione N.1 per allenatori di pallavolo
          </p>
          <h1 className="font-display text-4xl font-bold uppercase leading-[.91] tracking-tight text-white sm:text-6xl md:text-7xl" data-id="element-105">
            Pianifica tutta la tua stagione di pallavolo{' '}
            <span className="text-emerald-300" data-id="element-106">in meno di 5 minuti.</span>
          </h1>

          <div className="relative mx-auto mt-3 w-full max-w-[340px] lg:hidden" data-id="element-107">
            <div className="absolute inset-4 rounded-full border border-emerald-300/25" aria-hidden="true" data-id="element-108" />
            <img src={productImage} alt="PALLAVOLO PRONTA: set completo con sei volumi professionali" width={1080} height={720} fetchPriority="high" className="relative z-10 w-full object-contain drop-shadow-2xl" data-id="element-109" />
          </div>

          <p className="mx-auto mt-4 max-w-xl text-sm font-medium leading-relaxed text-slate-300 sm:text-lg lg:mx-0 lg:mt-6 lg:text-base" data-id="element-110">
            PALLAVOLO PRONTA™ è il tuo set completo 6-in-1: oltre 300 sessioni
            pronte all&apos;uso, drill, progressioni e strumenti di
            pianificazione. Tutto già fatto per te.
          </p>
          <ul className="mx-auto mt-4 flex max-w-xl flex-wrap justify-center gap-x-5 gap-y-2 text-sm font-semibold text-white lg:mx-0 lg:mt-6 lg:justify-start" data-id="element-111">
            {['6 Volumi professionali', '5 Bonus strategici', '300+ Sessioni pronte', '120+ Drill e giochi didattici', 'Tutte le categorie'].map(item => <li key={item} className="flex items-center gap-1.5" data-id="element-112">
                <CheckCircle2Icon className="h-4 w-4 text-emerald-300" data-id="element-113" />
                {item}
              </li>)}
          </ul>
          <a href="https://pallavolo-pronta.impultienda.ar/checkout" className="cta-button hero-cta mt-5 inline-flex w-full items-center justify-center whitespace-nowrap rounded-[22px] px-5 py-6 text-lg font-bold sm:text-xl lg:mt-8 lg:w-auto" data-id="element-114">
            OTTIENI PALLAVOLO PRONTA ORA
          </a>
          <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-[#B0B0C0] lg:mt-6 lg:justify-start" data-id="element-115">
            <span className="flex items-center gap-1.5" data-id="element-116">
              <LockKeyholeIcon className="h-4 w-4 text-emerald-300" data-id="element-117" />
              Pagamento sicuro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-118">
              <ZapIcon className="h-4 w-4 text-emerald-300" data-id="element-119" />
              Accesso immediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-120">
              <ShieldCheckIcon className="h-4 w-4 text-emerald-300" data-id="element-121" />
              Garanzia di 7 giorni
            </span>
          </div>
        </div>

        <div className="relative mx-auto hidden w-[132%] max-w-none lg:block" data-id="element-122">
          <div className="absolute inset-8 rounded-full border border-emerald-300/25" aria-hidden="true" data-id="element-123" />
          <img src={productImage} alt="PALLAVOLO PRONTA: set completo con sei volumi professionali" width={1080} height={720} fetchPriority="high" className="relative z-10 w-full object-contain drop-shadow-2xl" data-id="element-124" />
          <p className="relative z-10 mx-auto -mt-4 w-fit border border-emerald-400/30 bg-[#10251d] px-4 py-2 text-center text-xs font-bold uppercase tracking-widest text-emerald-300" data-id="element-125">
            La tua stagione, già pianificata
          </p>
        </div>
      </div>
    </section>;
}